/**
 * This is a template for new plugin wrappers
 *
 * TODO:
 * - Add/Change information below
 * - Document usage (importing, executing main functionality)
 * - Remove any imports that you are not using
 * - Remove all the comments included in this template, EXCEPT the @Plugin wrapper docs and any other docs you added
 * - Remove this note
 *
 */
import { Injectable } from '@angular/core';
import { Plugin, Cordova, IonicNativePlugin } from '@ionic-native/core';

export interface Printer {
  name: string;
  address: string;
}

export interface PrinterStatus {
  connected: boolean;
  isReadyToPrint?: boolean;
  isPaused?: boolean;
  isReceiveBufferFull?: boolean;
  isRibbonOut?: boolean;
  isPaperOut?: boolean;
  isHeadTooHot?: boolean;
  isHeadOpen?: boolean;
  isHeadCold?: boolean;
  isPartialFormatInProgress?: boolean;
}

/**
 * @name Zebra Printer
 * @description
 * This plugin does something
 *
 * @usage
 * ```typescript
 * import { ZebraPrinter } from '@ionic-native/zebra-printer';
 *
 *
 * constructor(private zebraPrinter: ZebraPrinter) { }
 *
 * ...
 *
 *
 * this.zebraPrinter.functionName('Hello', 123)
 *   .then((res: any) => console.log(res))
 *   .catch((error: any) => console.error(error));
 *
 * ```
 */
@Plugin({
  pluginName: 'ZebraPrinter',
  plugin: 'ca-cleversolutions-zebraprinter', // npm package name, example: cordova-plugin-camera
  pluginRef: 'cordova.plugins.zebraPrinter', // the variable reference to call the plugin, example: navigator.geolocation
  repo: 'git@github.com:cleversolutions/cordova-zebra-printer.git', // the github repository URL for the plugin
  install: '', // OPTIONAL install command, in case the plugin requires variables
  installVariables: [], // OPTIONAL the plugin requires variables
  platforms: ['Android', 'iOS'] // Array of platforms supported, example: ['Android', 'iOS']
})

export class ZebraPrinter extends IonicNativePlugin {
  @Cordova()
  echo(value: string ): Promise<any> { return; }
  @Cordova()
  print(cpcl: string ): Promise<any> { return; }
  @Cordova()
  isConnected(): Promise<boolean> { return; }
  @Cordova()
  printerStatus(adderss: string): Promise<PrinterStatus> { return; }
  @Cordova()
  connect(adress: string): Promise<any> { return; }
  @Cordova()
  disconnect(): Promise<any> { return; }
  @Cordova()
  discover(): Promise<Array<Printer>> { return; }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
